import { createFileRoute } from "@tanstack/react-router";
import { FeatureFlagsPage } from "@/pages/admin-feature-flags/ui/feature-flags-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/feature-flags",
)({
  component: FeatureFlagsPage,
});
